import React, { Component } from 'react';
import StyledProduct from './ProductCard.style';

class ProductCard extends Component {
  render = () => {
    const {
      product,
      showProductDetails,
      showTryOn,
      currency,
      ARMethods,
      selectedProductsForTryOn,
      configOptions,
    } = this.props;
    const trimmedName = product.name.substring(0, 44);
    const trimmedDesc = product.description.substring(0, 60);
    let hexcode;
    if (product.hasOwnProperty('filter_match') && Array.isArray(product.filter_match)) {
      let colorattribute = product.filter_match.find(a => {
        return typeof a === 'string' && a.startsWith('color_hex_');
      });
      if (colorattribute) {
        let colorValue = colorattribute.split('_')[2];
        colorValue = colorValue.replace('0x', '');
        colorValue = colorValue.replace('#', '');
        hexcode = '#' + colorValue;
      }
    }
    const tryOnAvailable = ARMethods.canVisualizeProduct(product);
    const tryOnActive =
      selectedProductsForTryOn &&
      selectedProductsForTryOn.hasOwnProperty(product.category) &&
      selectedProductsForTryOn[product.category].id === product.id;
    let price = null;
    if (product.price && currency) {
      price = product.price.toLocaleString('en-US', { style: 'currency', currency: currency });
    }
    const showSeeAllButton = configOptions.results.seeAllButton && configOptions.results.seeAllButton.show;
    const showBuyNowButton = configOptions.results.buyNowButton && configOptions.results.buyNowButton.show;
    return (
      <StyledProduct onClick={() => showProductDetails(product)}>
        <div className="label">
          {product.category}
          {product.custom_data && product.custom_data.subcategory && ` ${product.custom_data.subcategory}`}
        </div>
        {product.custom_data && product.custom_data.rating && (
          <div className="ratingSection">
            <div className="ratingValue">{product.custom_data.rating} / 5</div>
            <div className="reviewCountValue">{product.custom_data.reviewCount} reviews</div>
          </div>
        )}
        {tryOnAvailable && (
          <button
            className={tryOnActive ? 'tryon active' : 'tryon'}
            onClick={e => {
              e.stopPropagation();
              showTryOn(product);
            }}
          >
            Try On
          </button>
        )}
        <div className={showBuyNowButton || showSeeAllButton ? 'infobox infoboxSmall' : 'infobox'}>
          <img src={product.image} alt="" />
          <div className="details">
            <div className="name">{trimmedName}</div>
            <div className="desc">{trimmedDesc + '...'}</div>
            <div className="price">{price}</div>
          </div>
        </div>
        {(showSeeAllButton || showBuyNowButton) && (
          <div className="infobox infoboxBottom">
            {showBuyNowButton && (
              <button
                disabled={!configOptions.results.buyNowButton.callback}
                onClick={
                  configOptions.results.buyNowButton.callback ? eval(configOptions.results.buyNowButton.callback) : null
                }
              >
                {configOptions.results.buyNowButton.text}
              </button>
            )}
            {showSeeAllButton && <button>{configOptions.results.seeAllButton.text}</button>}
          </div>
        )}
        {hexcode && <div className="color" style={{ backgroundColor: hexcode }} />}
      </StyledProduct>
    );
  };
}

export default ProductCard;



// WEBPACK FOOTER //
// ./src/components/instore/ProductCard.js